import { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastProvider } from '@/contexts/ToastContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { ShortcutProvider } from '@/contexts/ShortcutContext';
import { ModalStackProvider } from '@/contexts/ModalStackContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import {
  ErrorBoundary,
  QueryErrorBoundary,
} from '@/components/ui/ErrorBoundary';
import { createQueryClient } from '@/utils/query-client-config';

interface AppProvidersProps {
  children: ReactNode;
  queryClient?: QueryClient;
}

export const AppProviders = ({
  children,
  queryClient = createQueryClient(),
}: AppProvidersProps) => {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <AuthProvider>
              <ShortcutProvider>
                <ModalStackProvider>
                  <QueryErrorBoundary>{children}</QueryErrorBoundary>
                </ModalStackProvider>
              </ShortcutProvider>
            </AuthProvider>
          </ToastProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};
